import { Col, Row } from 'antd'
import styled from '@emotion/styled'

export const RowAntd = styled(Row)``

export const ColAntd = styled(Col)``
